import Vue from "vue";
import { MutationTree } from "vuex";
import * as types from "./types";
import api from "@orgmap/api";
import { uGetWeekEndDate } from "@/modules/@appbase/util";
import { TWishContainerValueType } from "@orgmap/types/enums";
import { ContactsStoredType } from "../api/favorite";

export type TWishContainerSelectPayload = {
    id: number;
    item: orgmap.TWishContainerItem;
};
export type TWishContainerSelectAllPayload = {
    id: number;
    select: boolean;
};

export type TOrgContainerItemAddMutationPayload = {
    containerId: number;
};

export type TOrgContainerItemDelMutationPayload = {
    containerId: number;
};

export type TOrgContainerActivateMutationPayload = {
    containerId: number;
};

export interface OrgMemberListMutationPayload extends orgmap.TMemberList {}

export type OrgMemberSelectMutationPayload = {
    select: boolean;
    items: orgmap.TMemberItem[];
};

export default <MutationTree<orgmap.state.OrgmapState>>{
    [types.ORG_SELECT_TREE_ITEM](state, payload: boolean) {
        state.selectTreeItem = payload;
    },

    [types.ORG_ME](state, user: orgmap.TUser) {
        state.user = user;
    },

    //
    // ──────────────────────────────────────────────────── I ──────────
    //   :::::: C O M M O N S : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────────
    //

    [types.ORG_OPTION_SET](state, payload: orgmap.TWishContainerOptions) {
        state.options = payload;
    },

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E M B E R S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    [types.ORG_MEMBER_LIST](state, payload: OrgMemberListMutationPayload) {
        state.members = payload;
    },

    [types.ORG_MEMBER_SELECT](state, payload: OrgMemberSelectMutationPayload) {
        const { select, items } = payload;
        if (state.options.single) {
            state.members.items.forEach((x) => (x.selected = false));
        }
        items.forEach((item) => {
            const found = state.members.items.find(
                (x) => x.id === item.id && x.deptCode === item.deptCode && x.roleCode === item.roleCode
            );
            if (found) {
                found.selected = select;
                if (state.options.single) {
                    if (state.wish?.length) {
                        var container = state.wish[0];
                        if (container) {
                            const selItems = state.members.items.filter((x) => {
                                return (
                                    // 선택된 아이템
                                    x.selected
                                );
                            });

                            const flatten = function (list: Array<orgmap.TMemberItem>): Array<orgmap.TMemberItem> {
                                const stack = [...list];
                                const res: Array<orgmap.TMemberItem> = [];
                                while (stack.length) {
                                    const next = stack.pop();
                                    if (next) {
                                        if (["IPM.DistList", "G"].includes(next.type || "")) {
                                            next.children?.forEach((x) => {
                                                if (res.findIndex((a) => a.email === x.email && a.id === x.id) < 0) {
                                                    res.push(x);
                                                }
                                            });
                                        } else {
                                            if (res.findIndex((a) => a.email === next.email && a.id === next.id) < 0) {
                                                res.push(next);
                                            }
                                        }
                                    }
                                }
                                return res.reverse();
                            };

                            const flattened = flatten(selItems);
                            const newItems = [
                                ...flattened
                                    .filter((a) => {
                                        return (
                                            // 중복 제거
                                            container.items.findIndex((y) => y.value === a.email && y.id === a.id) < 0
                                        );
                                    })
                                    .map<orgmap.TWishContainerItem>((x: any) => ({
                                        ...x,
                                        text: x.name,
                                        value: x.email,
                                        selected: false,
                                    })),
                            ];
                            container.items = newItems;
                            evalContainerSelectAll(container);
                        }
                    }
                }
            }
        });

        evalMembersSelectAll(state.members);
    },

    [types.ORG_MEMBER_SELECT_ALL](state, payload: boolean) {
        state.members.items = state.members.items.map((x) => ({
            ...x,
            selected: payload,
        }));
        state.members.selectedAll = payload;
    },

    //
    // ──────────────────────────────────────────────────────────────────── I ──────────
    //   :::::: W I S H   C O N T A I N E R : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────────────────────────
    //

    [types.ORG_CONTAINER_REGISTER](
        state,
        payload: orgmap.TWishContainerOptionItem
    ) {
        if (state.wish.findIndex((x) => x.id === payload.id) < 0) {
            const containerItem = payload.items?.filter((item) => {
                return item.valueType == null;
            });

            const newContainer: orgmap.TWishContainer = {
                ...payload,
                selectedAll: false,
                items: containerItem?.map((x) => ({ ...x, selected: x.selected })) || [],
                activated: payload.id === 0,
            };

            const hasValueTypeItem = payload.items?.filter((item) => {
                return item.valueType != null;
            });

            if (hasValueTypeItem && hasValueTypeItem.length > 0) {
                let apiArr = [] as any[];

                hasValueTypeItem.forEach((item) => {
                    //API 분기 필요 함
                    //우선 /api/hr/department/search? 로 커버
                    if (item.valueType == TWishContainerValueType.email) {
                        //이메일
                        // apiArr.push(api.hr.getUserInfo(item.value))
                    } else if (item.valueType == TWishContainerValueType.personCode) {
                        //personCode
                        // apiArr.push(api.publics.getPersonInfo(item.value))
                    } else if (item.valueType == TWishContainerValueType.deptCode) {
                        //부서코드
                    }
                    // includeAllFlag: false
                    // query: "fl_mark"
                    // retiredFlag: false

                    apiArr.push(
                        api.hr.searchOrg(
                            {
                                includeAllFlag: false,
                                query: item.value,
                                retiredFlag: false,
                            },
                            "FL"
                        )
                    );
                });
                Promise.all(apiArr).then((result) => {
                    result.forEach((r) => {
                        var idxNo = result.indexOf(r);

                        if (r.items.length > 0)
                            newContainer.items.push({
                                ...r.items[0],
                                text: r.items[0].displayName,
                                selected: hasValueTypeItem[idxNo].selected,
                                personCode: hasValueTypeItem[idxNo].valueType == 2 ? "" : r.items[0].id,
                                value: r.items[0].email,
                                title: r.items[0].titleName,
                            });
                    });
                    //state.wish = [...state.wish, newContainer]
                });
            }

            state.wish = [...state.wish, newContainer];
        }
    },

    [types.ORG_CONTAINER_UPDATE](state, payload: orgmap.TWishContainerOptionItem) {
        if (state.wish.findIndex((x) => x.id === payload.id) > -1) {
            var container = state.wish.find((x) => x.id === payload.id);
            if (container) {
                const newContainer: orgmap.TWishContainer = {
                    ...container,
                    items: payload.items?.map((x) => ({ ...x, selected: false })) || [],
                };

                state.wish = state.wish.map((a) => {
                    if (a.id === newContainer.id) {
                        return newContainer;
                    } else {
                        return a;
                    }
                });
            }
        }
    },

    [types.ORG_CONTAINER_ITEM_SELECT](state, payload: TWishContainerSelectPayload) {
        const { id, item } = payload;
        const container = state.wish.find((c) => c.id === id);
        if (container) {
            container.items = container.items.map((x) => {
                if (x.id === item.id) {
                    // value 로 비교시 부서의 경우 고유키가 되지 못함
                    return {
                        ...x,
                        selected: !x.selected,
                    };
                } else return x;
            });
            evalContainerSelectAll(container);
        }
    },

    [types.ORG_CONTAINER_ITEM_SELECT_ALL](state, payload: TWishContainerSelectAllPayload) {
        const { id, select } = payload;
        const container = state.wish.find((c) => c.id === id);
        if (container) {
            container.items = container.items.map((c) => ({
                ...c,
                selected: select,
            }));
            evalContainerSelectAll(container);
        }
    },

    [types.ORG_CONTAINER_CLEAR](state) {
        state.wish = [];
    },

    [types.ORG_CONTAINER_DEPT_ITEM_ADD](state, payload: orgmap.TWishContainerItem) {
        const container = state.wish.find((c) => c.activated === true);

        if (container) {
            if (container.items.findIndex((x) => x.id === payload.id) < 0) {
                // 중복 제거
                const newItems = [...container.items, payload];
                container.items = newItems;
                evalContainerSelectAll(container);
            }
        }
    },

    async [types.ORG_CONTAINER_ITEM_ADD](state, { containerId }: TOrgContainerItemAddMutationPayload) {
        const container = state.wish.find((c) => c.id === containerId);
        if (container) {
            let selMembers = state.members.items.filter((m) => m.selected);

            if (state.currentTab === "personal") {
                let distMembers: orgmap.ContactItem[] = [];
                let distList = selMembers.filter((m) => m.type === "IPM.DistList");

                for (let i = 0; i < distList.length; i++) {
                    let members = await api.group.getGroupMembers(distList[i].id, ContactsStoredType.EWS);
                    distMembers = distMembers.concat(members.items);
                }

                selMembers = selMembers.filter((m) => m.type !== "IPM.DistList");
                selMembers = selMembers.concat(
                    distMembers.map(
                        (x) =>
                            <orgmap.TMemberItem>{
                                id: x.id,
                                name: x.displayName || "",
                                nameEn: x.displayNameEng || "",
                                deptCode: x.department || "",
                                deptName: x.department || "",
                                deptNameEn: x.department || "",
                                deptNameCh: x.deptNameCh || "",
                                photo: x.photoPath,
                                title: x.jobTitle || "",
                                titleEn: x.jobTitle || "",
                                titleCh: x.jobTitle || "",
                                email: x.email,
                                mobile: x.mobileTel || "",
                                tel: x.officeTel || "",
                                comCode: x.comCode,
                                company: x.companyName || "",
                                personCode: "",
                                selected: false,
                                type: x.itemClass || x.type,
                            }
                    )
                );
            }

            const selItems = selMembers.filter((x) => {
                return (
                    container.items.findIndex((y: any) => {
                        if (!!y.value) {
                            return y.value === x.email && y.id === x.id;
                        } else {
                            return y.id === x.id;
                        }
                    }) < 0
                );
            });

            const flatten = function (list: Array<orgmap.TMemberItem>): Array<orgmap.TMemberItem> {
                const stack = [...list];
                const res: Array<orgmap.TMemberItem> = [];
                while (stack.length) {
                    const next = stack.pop();
                    if (next) {
                        if (res.findIndex((a) => a.email === next.email && a.id === next.id) < 0) {
                            res.push(next);
                        }
                    }
                }
                return res.reverse();
            };

            const flattened = flatten(selItems);
            const newItems = [
                ...container.items,
                ...flattened
                    .filter((a) => {
                        return (
                            // 중복 제거
                            container.items.findIndex((y) => y.value === a.email && y.id === a.id) < 0
                        );
                    })
                    .map<orgmap.TWishContainerItem>((x: any) => ({
                        ...x,
                        text: x.name,
                        value: x.email,
                        selected: false,
                        isDept: x.personId ? false : true,
                    })),
            ];
            container.items = newItems;
            evalContainerSelectAll(container);
            state.members.items = state.members.items.map((x) => ({
                ...x,
                selected: false,
            }));
            evalMembersSelectAll(state.members);
        }
    },

    [types.ORG_CONTAINER_ITEM_DEL](state, { containerId }: TOrgContainerItemDelMutationPayload) {
        const container = state.wish.find((c) => c.id === containerId);
        if (container) {
            container.items = container.items.filter((x) => !x.selected);
            evalContainerSelectAll(container);
        }
    },

    [types.ORG_CONTAINER_ACTIVATE](state, { containerId }: TOrgContainerActivateMutationPayload) {
        const container = state.wish.find((c) => c.id === containerId);
        if (container) {
            state.wish = state.wish.map((x) => {
                if (x === container) {
                    return {
                        ...x,
                        activated: true,
                    };
                } else {
                    return {
                        ...x,
                        activated: false,
                    };
                }
            });
        }
    },

    //
    // ──────────────────────────────────────────────────── I ──────────
    //   :::::: M O B I L E : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────────
    //

    [types.ORG_USER_SELECT](state, payload: orgmap.TUser) {
        var personMail = payload.email;
        var index = state.selections.users.findIndex((user) => user.email == personMail);
        if (index > -1) state.selections.users.splice(index, 1);
        else state.selections.users.push(payload);
    },

    [types.ORG_USER_SELECT_CLEAR](state) {
        state.selections.users = [];
    },

    [types.ORG_USER_SELECT_SET](state, payload: any[]) {
        state.selections.users = payload;
    },

    [types.ORG_CURRENT_TAB](state, payload: "hr" | "personal" | "public") {
        state.members = {
            items: [],
            selectedAll: false,
            totalCount: 0,
        };
        state.currentTab = payload;
    },

    [types.SEARCH_CHANGE](state, options: orgmap.SearchOptions) {
        state.search = {
            ...state.search,
            ...options,
        };
    },

    //
    // ──────────────────────────────────────────────────── I ──────────
    //   :::::: C O M P A N Y : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────────
    //
    [types.ORG_COMPANY_CURRENT](state, company: orgmap.Company) {
        state.hr.currentCompany = company;
    },

    [types.ORG_COMPANY_LOAD](state, payload: Array<orgmap.Company>) {
        state.hr.companies = payload;
    },

    [types.ORG_COMPANY_LOAD_WITHDISABLE](state, payload: Array<orgmap.Company>) {
        state.hr.companies = payload;
    },

    //
    // ──────────────────────────────────────────────────── I ──────────
    //   :::::: H R : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────────
    //

    // 부서 목록을 조회합니다.
    [types.HR_TREE_LIST](state, data: { parentDeptCode: string; children: Array<any> }) {
        const parentDeptCode = data.parentDeptCode;

        function flatToHierarchy(flat: Array<orgmap.Department>) {
            var roots: any[] = [];
            var all: any = {};
            var flatArr: any[] = [];
            for (var item of flat) {
                all[item.id] = {
                    ...item,
                    children: null,
                    expanded: false,
                    selected: false,
                } as orgmap.Department;
                flatArr.push(all[item.id]);
            }
            flatArr.forEach(function (item) {
                const parentCode = item.parentDeptCode;
                if (!parentCode) {
                    roots.push(item);
                } else if (parentCode in all) {
                    var p = all[parentCode] as orgmap.Department;
                    if (!("children" in p) || !p.children) {
                        p.children = [];
                    }
                    p.children.push(item);
                } else {
                    roots.push(item);
                }
            });
            return roots;
        }
        const hierarchy = flatToHierarchy(data.children);

        const findDept = function (parent: Array<orgmap.Department>) {
            const result = parent.find((dept) => dept.deptCode === parentDeptCode);
            if (result) {
                return result;
            } else {
                var foundDept = null;
                parent.forEach((dept) => {
                    if (dept.children && dept.children.length > 0) {
                        var found = findDept(dept.children);
                        if (found && found !== undefined) {
                            foundDept = found;
                        }
                    }
                });
                return foundDept;
            }
        };
        const dept = findDept(state.hr.dept.items);
        if (dept) {
            dept.expanded = true;
            dept.children = hierarchy;
        } else {
            hierarchy.forEach((item) => (item.expanded = true));
            state.hr.dept.items = hierarchy;
        }
    },

    [types.HR_TREE_CURRENT](state, dept: orgmap.Department) {
        if (dept) {
            const { deptCode } = dept;
            state.hr.dept.current = {
                ...dept,
                selected: true,
            };
            const select = (depts: orgmap.Department[]) => {
                depts.forEach((dept) => {
                    dept.selected = dept.deptCode === deptCode;
                    if (dept.hasChildren && dept.children) {
                        select(dept.children);
                    }
                });
            };
            select(state.hr.dept.items);
        } else {
            state.hr.dept.current = null;
        }
    },

    [types.HR_TREE_CURRENT_V2](state, dept: orgmap.Department) {
        if (dept) {
            const { deptCode } = dept;
            state.hr.dept.current = {
                ...dept,
                selected: true,
            };
            const select = (depts: orgmap.Department[]) => {
                depts.forEach((dept) => {
                    dept.selected = dept.deptCode === deptCode;
                    if (dept.hasChildren && dept.children) {
                        select(dept.children);
                    }
                });
            };
            select(state.hr.dept.items);
        } else {
            state.hr.dept.current = null;
        }
    },

    [types.HR_TREE_PATH](state, path: Array<orgmap.DepartmentOption>) {
        state.hr.dept.path = path;
    },

    [types.HR_USERS_LIST](state, payload: orgmap.PagedItemList<orgmap.UserItem>) {
        const { items, totalCount } = payload;
        state.hr.user.items = items.map((item: orgmap.UserItem) => {
            return {
                ...item,
                selected: false,
                type: "hr",
            };
        });
        state.hr.user.totalCount = totalCount;
        state.hr.user.selectAll = false;
        state.hr.user.current = null;
    },

    [types.HR_USERS_LIST_V2](state, payload: orgmap.PagedItemList<orgmap.UserItem>) {
        const { items, totalCount } = payload;
        state.hr.user.items = items.map((item: orgmap.UserItem) => {
            return {
                ...item,
                selected: false,
                type: "hr",
            };
        });
        state.hr.user.totalCount = totalCount;
        state.hr.user.selectAll = false;
    },

    [types.HR_USERS_CURRENT](state, user: orgmap.UserItem) {
        user.selected = !user.selected;
        state.hr.user.current = user;
        Vue.nextTick(() => {
            const items = state.hr.user.items;
            if (items.length === items.filter((item) => item.selected).length) {
                state.hr.user.selectAll = true;
            } else {
                state.hr.user.selectAll = false;
            }
        });

        let selectedUserList = state.hr.user.items.filter((item: any) => {
            if (item.selected == true) {
                return item;
            }
        });

        state.hr.user.usertotalCount = selectedUserList.length;
    },

    [types.HR_USER_SELALL](state, selectAll: boolean) {
        state.hr.user.items.forEach((item) => (item.selected = selectAll));
        state.hr.user.selectAll = selectAll;
        state.hr.user.usertotalCount = selectAll ? state.hr.user.items.length : 0;
    },
};

const evalMembersSelectAll = (members: orgmap.TMemberList) => {
    const stateItems = members.items;
    members.selectedAll = stateItems.length > 0 && stateItems.filter((x) => x.selected).length === stateItems.length;
};

const evalContainerSelectAll = (container: orgmap.TWishContainer) => {
    container.selectedAll =
        container.items.length > 0 && container.items.filter((x) => x.selected).length === container.items.length;
};
